import * as React from 'react'
import { cva } from 'class-variance-authority'

import { cn } from '@/lib/utils'
import {ReactNode} from "react";
// import { getHeadline } from '@/lib/fetch/components/getHeadline'

const headlineVariants = cva('col-span-full font-default font-bold lg:col-span-8', {
    variants: {
        variant: {
            default: 'h2',
            h1: 'h1',
            h2: 'h2',
            h3: 'h3',
            h4: 'h4',
            h5: 'h5',
            h6: 'h6'
        },
        size: {
            default: 'text-4xl',
            xxl: 'text-4xl xxl:text-5xl',
            xl: 'text-3xl md:text-4xl',
            lg: 'text-2xl',
            md: 'text-lg font-normal',
            sm: 'text-base font-normal uppercase tracking-wider',
            xs: 'text-sm font-normal uppercase tracking-widest'
        },
        position: {
            left: 'lg:col-start-0',
            center: 'lg:col-start-3',
            right: 'lg:col-start-5'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
        position: 'left'
    }
})

interface HeadlineProps {
    className?: string;
    variant: any;
    position?: "left" | "center" | "right" | null | undefined;
    size: "default" | "xxl" | "xl" | "lg" | "md" | "sm" | "xs" | null | undefined;
    children: ReactNode;
}

const Headline = React.forwardRef(({ className, variant = 'h2', position = 'left', size, children, ...props }: HeadlineProps, ref) => {
    const Type = variant
    return <Type className={cn(headlineVariants({ variant, size, position, className }))} ref={ref} {...props}>
        {children}
    </Type>
})

/*
const HeadlineFetch = async ({ locale, id }: {locale: string, id: number}) => {
    // const content = await getHeadline(locale, id)

    return (
        <Headline variant={content.type} size={content.size} position={content.position}>
            {content.translations[0].headline}
        </Headline>
    )
}
 */
Headline.displayName = 'Headline'

export { Headline, headlineVariants }
